import React from "react";
import { Card } from "react-bootstrap";
import Bar from '../Bar';

const Final = ({ values }) => {

    //destructuring the object from values
  const { fullName, companyName, investmentValue, restaurantsValue, restaurantsValueLabel, email, phoneNumber } = values;
  return (
    <>
    <Bar/>
      <Card style={{ marginTop: 150, marginBottom: 150 }}>
        <Card.Body className="lh-lg">
        <p className="text-lg-center fw-bold h5 p-3 mb-2 bg-dark text-white"> <i className="bi bi-info-square"/> The Investor Information:</p>
          <p>
            <strong>Full Name :</strong> {fullName}{" "}
          </p>
          <p>
            <strong>Company Name :</strong> {companyName}{" "}
          </p>
          <p>
            <strong>Investment Value:</strong> {investmentValue}{" "}
          </p>
          <p>
            <strong>Email :</strong> {email}{" "}
          </p>
          <p>
            <strong>Phone :</strong> {phoneNumber}{" "}
          </p>
          <p>
            <strong>Selected Location :</strong> Syria, Damascus, 29th May
          </p>
            <p className="text-lg-center fw-bold h5 p-3 mb-2 bg-primary text-white"> <i className="bi bi-check-square"/> The Strengths Points of The Chosen location:</p>
            <p>
              <strong>1- The location overlooks a Public Street</strong> - (29th May Street)
            </p>
            <p>
              <strong>2- There is a place to park the car</strong> - (Private Parking)
            </p>
            <p>
            <strong>3- The area has a High Population Density</strong> - ()
            </p>
            <p className="text-lg-center fw-bold h5 p-3 mb-2 bg-danger text-white"> <i className="bi bi-x-square"/> The Weaknesses Points of The Chosen location:</p>
          <div className="text-wrap fw-bold" style={{width: "26rem"}}>
            {restaurantsValue}{""}
          </div>
          <p className="text-lg-center fw-bold h5 p-3 mb-2 bg-warning text-dark"> <i className="bi bi-award"/> The Result of The Chosen location:</p>
          <p>
            <strong>The Percentage of The End Result is :</strong> {restaurantsValueLabel}{" "}
          </p>
        </Card.Body>
      </Card>
    </>
  );
};

export default Final;